import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';

export const getMoneyDownSearchState = createSelector(
    fromFeature.getFeatureState,
    (state: fromFeature.FeatureState) => state.moneyDownSearch,
);
